export default "__VITE_ASSET__ebc17aff__"